import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 50%, #1a1a2e 100%)',
      borderTop: '1px solid rgba(0, 233, 255, 0.2)',
      padding: '40px 20px 20px 20px',
      marginTop: '60px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '30px'
        }}>
          {/* Brand Section */}
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <img 
                src="/flirteen-logo.png" 
                alt="Flirteen Logo" 
                style={{ 
                  height: '40px', 
                  marginRight: '12px',
                  filter: 'brightness(1.2)'
                }} 
              />
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                background: 'linear-gradient(45deg, #00E9FF, #E0005B)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                margin: 0
              }}>
                Flirteen
              </h3>
            </div>
            <p style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '14px',
              lineHeight: '1.6',
              marginBottom: '20px'
            }}>
              Connecting hearts, creating love stories. Find your perfect match with Flirteen - where meaningful relationships begin.
            </p>
            <div style={{
              display: 'flex',
              gap: '15px'
            }}>
              <a
                href="mailto:hello@flirteen.com"
                style={{
                  color: '#00E9FF',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
              >
                📧 hello@flirteen.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              color: '#00E9FF',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '20px'
            }}>
              Quick Links
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  🏠 Home
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/blog"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  📝 Dating Blog
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    // Check if we're in the main app (user logged in)
                    const appElement = document.querySelector('[class*="nav-button"]');
                    if (appElement) {
                      // User is logged in, trigger premium page
                      const premiumButton = Array.from(document.querySelectorAll('button')).find(btn => btn.textContent.includes('💎 Premium'));
                      if (premiumButton) {
                        premiumButton.click();
                      }
                    } else {
                      // User not logged in, redirect to login
                      window.location.href = '/';
                    }
                  }}
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  💎 Premium
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="mailto:support@flirteen.com"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  💬 Help & Support
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Policies */}
          <div>
            <h4 style={{
              color: '#00E9FF',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '20px'
            }}>
              Legal & Policies
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/terms"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  📋 Terms & Conditions
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/privacy"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  🔒 Privacy Policy
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/safety"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  🛡️ Safety Guidelines
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/community"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  👥 Community Guidelines
                </a>
              </li>
            </ul>
          </div>

          {/* About & Contact */}
          <div>
            <h4 style={{
              color: '#00E9FF',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '20px'
            }}>
              About & Contact
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="/about"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  ℹ️ About Us
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="mailto:support@flirteen.com"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  📞 Contact Support
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a
                  href="mailto:feedback@flirteen.com"
                  style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00E9FF'}
                  onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                >
                  💭 Send Feedback
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '20px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '14px'
          }}>
            © {currentYear} Flirteen. All rights reserved. Made with 💕 for finding love.
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px'
          }}>
            <div style={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '12px'
            }}>
              🌟 Trusted by thousands of singles
            </div>
            <div style={{
              background: 'rgba(0, 233, 255, 0.1)',
              borderRadius: '20px',
              padding: '4px 12px',
              border: '1px solid rgba(0, 233, 255, 0.3)'
            }}>
              <span style={{
                color: '#00E9FF',
                fontSize: '12px',
                fontWeight: '600'
              }}>
                💝 Safe & Secure
              </span>
            </div>
          </div>
        </div>

        {/* Mobile Responsive Notice */}
        <div style={{
          marginTop: '15px',
          textAlign: 'center'
        }}>
          <p style={{
            color: 'rgba(255, 255, 255, 0.5)',
            fontSize: '12px',
            margin: 0
          }}>
            Best experience on desktop • Available 24/7
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;